<template>
  <v-tooltip bottom>
    <template #activator="{ on }">
      <v-icon color="orange" style="margin: 0 5px" @click="allIntegrationLogs" v-on="on">
        mdi-form-select
      </v-icon>
    </template>
    <span v-text="$t('monitoring.see_all_logs')" />
  </v-tooltip>
</template>
<script>
import Utils from '../../utils'

export default {
  name: 'GoToAllIntegrationLogs',

  props: { integration: Object },

  methods: {
    allIntegrationLogs () {
      const { processType, integrationID } = this.integration
      const lastDate = Utils.rawDate(this.integration.lastDate)
      const endDate = Utils.dateFormatHyphened(lastDate)
      const query = {
        processType,
        integrationID,
        startDate: Utils.dateBeforeThisDayNumber(endDate, 7),
        endDate
      }
      const someQueryFieldIsInvalid = Object.values(query).some(v => !v)
      if (someQueryFieldIsInvalid) { return }
      this.$router.push({ path: 'all-integration-logs', query })
    }
  }

}
</script>
